import * as React from 'react';
import { SVGProps } from 'react';

const SvgFileSync = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_3651_9897)'>
      <path
        d='M10.3932 17.5892C14.1458 17.5892 17.1878 14.5471 17.1878 10.7946C17.1878 7.04204 14.1458 4 10.3932 4C6.64067 4 3.59863 7.04204 3.59863 10.7946C3.59863 12.2738 4.07129 13.6425 4.8738 14.7581'
        stroke={props.stroke || 'black'}
        strokeWidth='1.5'
      />
      <line
        x1='2'
        y1='17.6385'
        x2='10.793'
        y2='17.6385'
        stroke={props.stroke || 'black'}
        strokeWidth='1.5'
      />
      <line
        x1='16.3887'
        y1='17.6385'
        x2='21.9842'
        y2='17.6385'
        stroke={props.stroke || 'black'}
        strokeWidth='1.5'
      />
      <path
        d='M19.1738 14.7914L22 17.6176L19.1738 20.4438'
        stroke={props.stroke || 'black'}
        strokeWidth='1.5'
      />
    </g>
    <defs>
      <clipPath id='clip0_3651_9897'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgFileSync;
